import {
  EMethods,
  EPromotionTypes,
  IState,
  ECampaignStatus,
  ISearchQuery,
  IFilterOption,
  IFilter,
} from "store/store.interface";
import {
  BUNDLE_PROMOTION_SET_TYPE,
  BUNDLE_PROMOTION_SET_FIELDS,
  BUNDLE_PROMOTION_GET_FIELDS,
  BUNDLE_PROMOTION_SET_VALUE,
  BUNDLE_PROMOTION_CREATE,
  BUNDLE_ADD_NEW_CAMPAGIN_TO_THE_LIST,
  BUNDLE_CLEAR_CREATION_BUNDLE_FORM,
  BUNDLE_PROMOTION_FETCH_CAMPAIGNS,
  BUNDLE_PROMOTION_SET_CAMPAIGNS,
  BUNDLE_PROMOTION_GET_CAMPAIGN_BY_ID,
  BUNDLE_PROMOTION_SET_CAMPAIGN_BY_ID,
  BUNDLE_PROMOTION_UPDATE_STATUS,
  BUNDLE_PROMOTION_UPDATE_CAMPAIGN,
  BUNDLE_PROMOTION_UPDATE_PAGE_NUMBER,
  BUNDLE_PROMOTION_CLEAR_CAMPAIGNS_LIST,
  BUNDLE_PROMOTION_UPDATE_FILTER,
  BUNDLE_PROMOTION_RESET_FILTER,
  CREATE_RESOURCE,
  RESOURCE_DATA,
  RESOURCE_GET_BY_ID,
} from "../store.types";
import { IBundleDashboard, IQuery } from '../reducers/bundlePromotion.reducers'
import { Dispatch } from "redux";
import _ from "lodash";
import {
  apiAction,
  replaceUrlVariables,
} from "store/middlewares/api.middleware.helper";
import { staticApiEndpoints, endpoints } from "constant";
import { getBundleCampaignPayload } from '../../components/BundlePromotion/BundleHelpers'
import { downloadCSV } from "utils/app.utils";
import { setSearchTerm } from "./promotion.actions";

export const setBundlePromotionType = (promotionType: EPromotionTypes) => ({
  type: BUNDLE_PROMOTION_SET_TYPE,
  payload: promotionType,
});

export const fetchBundleFieldsDetails =
  () => (dispatch: Dispatch, getState: () => IState) => {
    const {
      bundlePromotion: {
        creationBundleForm: { type = "" },
      },
    } = getState();
    const endpoint = replaceUrlVariables(staticApiEndpoints.FIELDS, {
      type: type.toLowerCase(),
    });
    dispatch(
      apiAction({
        url: endpoint,
        withToken: true,
        label: BUNDLE_PROMOTION_GET_FIELDS,
        data: {},
        isStatic: true,
        method: EMethods.GET,
        onSuccess: ({ data }) => ({
          type: BUNDLE_PROMOTION_SET_FIELDS,
          payload: data,
        }),
      })
    );
  };

export const setBundlePromotionObject =
  (value: any, fieldName: string) =>
    (dispatch: Dispatch, getState: () => IState) => {
      const {
        bundlePromotion: { creationBundleForm },
      } = getState();
      const currentValues = { ...creationBundleForm };
      const updatedValues = {
        ...currentValues,
        [fieldName]: value,
      };

      if (!_.isEqual(updatedValues, creationBundleForm)) {
        dispatch({
          type: BUNDLE_PROMOTION_SET_VALUE,
          payload: updatedValues,
        });
      }
    };

export const addNewCampaignToTheList = (campaign: IBundleDashboard) => ({
  type: BUNDLE_ADD_NEW_CAMPAGIN_TO_THE_LIST,
  payload: campaign,
});

export const clearCreationBundleForm = () => ({
  type: BUNDLE_CLEAR_CREATION_BUNDLE_FORM,
});

export const createBundleCampiagn =
  () => (dispatch: Dispatch, getState: () => IState) => {
    const {
      bundlePromotion: {
        creationBundleForm,
      },
      auth: { email = '' }
    } = getState();
    let type = EPromotionTypes.BUNDLE_CAMPAIGN.toLowerCase();
    let updateForm = getBundleCampaignPayload(creationBundleForm, email) as IBundleDashboard;

    if (creationBundleForm.edit) {
      delete updateForm.edit
      delete updateForm.createdBy
      delete updateForm.offer.promotion
      delete updateForm?.offer?.bundleInfo?.discountQuantity
      delete updateForm?.offer?.bundleInfo?.mixAndMatch
      delete updateForm?.offer?.bundleInfo?.quantity
      delete updateForm?.offer?.bundleInfo?.text?.en?.badge
      delete updateForm?.offer?.bundleInfo?.text?.en?.firstTnc
      delete updateForm?.offer?.bundleInfo?.text?.en?.secondTnc
      delete updateForm?.offer?.bundleInfo?.text?.en?.offerText
      delete updateForm?.offer?.bundleInfo?.text?.ar?.badge
      delete updateForm?.offer?.bundleInfo?.text?.ar?.firstTnc
      delete updateForm?.offer?.bundleInfo?.text?.ar?.secondTnc
      delete updateForm?.offer?.bundleInfo?.text?.ar?.offerText
      updateForm.updatedBy = email
      updateForm.type = type
    }

    let updatedForm = JSON.parse(JSON.stringify(updateForm));

    dispatch(
      apiAction({
        url: creationBundleForm.edit ? replaceUrlVariables(endpoints.GET_BUNDLE_CAMPAIGN_BY_ID, {
          id: creationBundleForm.campaignId,
        }) : replaceUrlVariables(endpoints.CREATE_BUNDLE_CAMPAIGN, { type}),
        withToken: true,
        withStoreId: true,
        data: updatedForm,
        label: BUNDLE_PROMOTION_CREATE,
        method: creationBundleForm.edit ? EMethods.PUT : EMethods.POST,
        isBundlePromotion: true,
        onSuccess:
          ({ data }) =>
            (dispatch: Dispatch) => {
              if (!creationBundleForm.edit) {
                dispatch(addNewCampaignToTheList(data) as any);
              } else {
                dispatch({
                  type: BUNDLE_PROMOTION_UPDATE_CAMPAIGN,
                  payload: data
                })
              }
              dispatch(clearCreationBundleForm());
            },
      })
    );
  };

const getBundleFiltersValue = (filters?: IFilter[]) => {
  if (!filters?.length) return;

  const params = filters.reduce((acc: string[], { name, value }) => {
    const values = Array.isArray(value) ? value : [value];
    values.forEach((v) => {
      acc.push(`${name.toLowerCase()}=${encodeURIComponent(v)}`);
    });
    return acc;
  }, []);

  return params.join("&");
};  

export const fetchBundleCampaigns =
  (query?: IQuery) => (dispatch: Dispatch, getState: () => IState) => {
    const {
      config: { limit: defaultLimit },
    } = getState();
    const { page, filters, limit } = query || {};
    if (!page) {
      dispatch(clearBundleCampaingsList());
    }
    
    let endPoint = endpoints.FETCH_BUNDLE_CAMPAIGNS;
    const formatedFilters = getBundleFiltersValue(filters);
    if (formatedFilters) {
      endPoint = `${endPoint}?${formatedFilters}`;
    }

    dispatch(
      apiAction({
        url: endPoint,
        method: EMethods.GET,
        label: BUNDLE_PROMOTION_FETCH_CAMPAIGNS,
        withStoreId: true,
        withToken: true,
        isBundlePromotion: true,
        data: {
          page: page || 0,
          pageSize: limit || defaultLimit,
        },
        onSuccess: ({ data }) => ({
          type: BUNDLE_PROMOTION_SET_CAMPAIGNS,
          payload: data,
        }),
      })
    );
  };
  
 export const searchForBundleCampaigns =
  (query?: ISearchQuery) => (dispatch: Dispatch, getState: () => IState) => {
    const {
      config: { limit: defaultLimit },
    } = getState();
    const { page, limit, searchTerm } = query || {};
    if (!page) {
      dispatch(clearBundleCampaingsList());
    }
    dispatch(
      apiAction({
        url: endpoints.FETCH_BUNDLE_CAMPAIGNS,
        method: EMethods.GET,
        label: BUNDLE_PROMOTION_FETCH_CAMPAIGNS,
        withStoreId: true,
        withToken: true,
        isBundlePromotion: true,
        data: {
          name: searchTerm,
          page: page || 0,
          pageSize: limit || defaultLimit,
        },
        onSuccess: ({ data }) => ({
          type: BUNDLE_PROMOTION_SET_CAMPAIGNS,
          payload: data,
        }),
      })
    );
  };
  
  export const addBundleFilters =
    (filter: IFilterOption) => (dispatch: Dispatch, getState: () => IState) => {
      const {
        bundlePromotion: { filters = [] },
      } = getState();
      dispatch(setSearchTerm(""));
      let newFilters = filters;
      const restFilters = filters.filter((option) => option.name !== filter.name);
        const filterType = filters.filter(
          (option) => option.name === filter.name
        )[0];
        const isFilterExist = filterType?.value?.includes(filter?.value);
        if (!isFilterExist) {
          const updatedValue = filterType
            ? [...filterType.value, filter.value]
            : [filter.value];
          newFilters = [
            ...restFilters,
            { name: filter.name, value: updatedValue },
          ];
        }
      dispatch({
        type: BUNDLE_PROMOTION_UPDATE_FILTER,
        payload: newFilters,
      });
      dispatch(fetchBundleCampaigns({ filters: newFilters }) as any);
    };
  
  export const removeBundleFilters =
    (filter: IFilterOption) => (dispatch: Dispatch, getState: () => IState) => {
      const {
        bundlePromotion: { filters = [] },
      } = getState();
      dispatch(setSearchTerm(""));
      let newFilters = filters;
      const restFilters = filters.filter((option) => option.name !== filter.name);
        const filterType = filters.filter(
          (option) => option.name === filter.name
        )[0];
        const isFilterExist = filterType?.value?.includes(filter?.value);
        if (isFilterExist) {
          const updatedValues = filterType.value.filter(
            (value) => value !== filter.value
          );
          newFilters = [...restFilters];
          if (updatedValues.length > 0) {
            newFilters.push({
              name: filter.name,
              value: updatedValues,
            });
          }
        }
      dispatch({
        type: BUNDLE_PROMOTION_UPDATE_FILTER,
        payload: newFilters,
      });
      dispatch(fetchBundleCampaigns({ filters: newFilters }) as any);
    };
  
  export const resetBundleFilters = () => (dispatch: Dispatch) => {
    dispatch({
      type: BUNDLE_PROMOTION_RESET_FILTER,
    });
    dispatch(fetchBundleCampaigns() as any);
  };

export const sendPosInfoResoures = (data: FormData) => (dispatch:Dispatch, getState: () => IState) => {
  const {
    bundlePromotion: { creationBundleForm },
  } = getState();
  let { type = "" } = creationBundleForm;
  let endPoint = endpoints.CREATE_BUNDLE_POSINFO_RESOURCE;
  if (type === EPromotionTypes.FREE_GIFT) {
    endPoint = `${endPoint}?promotionType=${EPromotionTypes.FREE_GIFT}`;
  }

  dispatch(apiAction({
    forFileSend: true,
    url: endPoint,
    method: EMethods.POST,
    withToken: true,
    withStoreId: true,
    label: CREATE_RESOURCE,
    isBundlePromotion: true,
    data: data,
    onSuccess: ({data}) => (dispatch: Dispatch) =>{
      dispatch({
        type: RESOURCE_DATA,
        payload: data,
      });
    }
  }))
};

export const getPosInfoResource =
  (id?: string) => (dispatch: Dispatch, getState: () => IState) => {
    const {
      bundlePromotion: { creationBundleForm },
    } = getState();
    let { type = "" } = creationBundleForm;
    let endPoint = id
      ? replaceUrlVariables(endpoints.GET_BUNDLE_POSINFO_RESOURCE, { id })
      : endpoints.GET_BUNDLE_POSINFO_RESOURCE_TEMPLATE;

    if (type === EPromotionTypes.FREE_GIFT) {
      endPoint = `${endPoint}?promotionType=${EPromotionTypes.FREE_GIFT}`;
    }

    const fileName = id ? "posListPromotion.csv" : "posListTemplate.csv";
    dispatch(
      apiAction({
        url: endPoint,
        label: RESOURCE_GET_BY_ID,
        method: EMethods.GET,
        withStoreId: true,
        withToken: true,
        isBundlePromotion: true,
        data: {},
        onSuccess: (data) => () => {
          downloadCSV(data, fileName);
        },
      }),
    );
  };

export const getBundleCampaignById =
  (campaignId: string) => (dispatch: Dispatch) => {
    const endpoint = replaceUrlVariables(endpoints.GET_BUNDLE_CAMPAIGN_BY_ID, {
      id: campaignId,
    });
    dispatch(
      apiAction({
        url: endpoint,
        label: BUNDLE_PROMOTION_GET_CAMPAIGN_BY_ID,
        method: EMethods.GET,
        withStoreId: true,
        withToken: true,
        isBundlePromotion: true,
        data: {},
        onSuccess:
          ({ data }) => ({
            type: BUNDLE_PROMOTION_SET_CAMPAIGN_BY_ID,
            payload: { ...data, campaignId },
          }),
      })
    );
  };

export const updateBundleCampaignStatus =
  (campaignId: string, status: ECampaignStatus) =>
    (dispatch: Dispatch, getState: () => IState) => {
      const {
      auth: { email = '' }
    } = getState();
      const endpoint = replaceUrlVariables(endpoints.UPDATE_BUNDLE_CAMPAIGN_STATUS, {
        id: campaignId,
      });
      dispatch(
        apiAction({
          url: endpoint,
          method: EMethods.PATCH,
          label: BUNDLE_PROMOTION_UPDATE_STATUS,
          withToken: true,
          withStoreId: true,
          isBundlePromotion: true,
          data: {
            updatedBy: email,
            status,
          },
          onSuccess: () => ({
            type: BUNDLE_PROMOTION_UPDATE_STATUS,
            payload: { campaignId, status },
          })
        })
      );
    };

export const updateBundlePageNumber = (pageNumber: number) => ({
  type: BUNDLE_PROMOTION_UPDATE_PAGE_NUMBER,
  payload: pageNumber,
});

export const clearBundleCampaingsList = () => ({
  type: BUNDLE_PROMOTION_CLEAR_CAMPAIGNS_LIST,
});